import type { SortOrder } from '@travel-planner/shared/types';
import type { ReactNode } from 'react';
import { SORT_ORDER } from '@travel-planner/shared/types';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import css from './sortable-header.module.scss';

export type SortDirection = SortOrder | null;

type SortableHeaderProps = {
  active?: boolean;
  children: ReactNode;
  direction?: SortDirection;
  onClick?: () => void;
};

export const SortableHeader = ({
  active = false,
  children,
  direction = null,
  onClick,
}: SortableHeaderProps) => {
  const Icon =
    active && direction === SORT_ORDER.Asc
      ? ArrowUp
      : active && direction === SORT_ORDER.Desc
        ? ArrowDown
        : ArrowUpDown;

  return (
    <button className={css.root} onClick={onClick} type="button">
      {children}
      <Icon className={active ? css.iconActive : css.icon} />
    </button>
  );
};
